async function getClientIp() {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        return null;
    }
}

async function getCountryCode(ip) {
    try {
        const randomNum = Math.floor(Math.random() * 100000) + 1;
        const response = await fetch(`http://ipwhois.pro/${ip}?key=mDP1WDJVt2fXmKEE&random=${randomNum}`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.country_code;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        return 'UNKNOWN';
    }
}

async function main() {
    const clientIp = await getClientIp();
    if (clientIp === null) {
        console.error('Could not retrieve client IP address');
        return;
    }

    const countryCode = await getCountryCode(clientIp);

    //console.log('countryCode [' + countryCode + ']');

    function clickElementByVariantId(id) {
        document.querySelector('[data-variant-id="' + id + '"]').click();
        //console.log('click [' + id + ']');
    }

    if (['UK', 'GB', 'HK', 'SG', 'MY', 'AE', 'SA'].includes(countryCode)) {
        clickElementByVariantId(2);
    } else if (['US', 'CA', 'TW', 'PR', 'HI'].includes(countryCode)) {
        clickElementByVariantId(3);
    } else if (['AU', 'CN'].includes(countryCode)) {
        clickElementByVariantId(4);
    }
}

main();
